
export default function ComparisonTable() {
  const rows = [
    { name: 'QuickBooks Online', price: '$30/mo', bestFor: 'Growing SMBs', key: '750+ integrations' },
    { name: 'Xero', price: '$15/mo', bestFor: 'Teams needing unlimited users', key: 'Smart bank reconciliation' },
    { name: 'FreshBooks', price: '$19/mo', bestFor: 'Service-based businesses', key: 'Best-in-class invoicing' },
    { name: 'Wave', price: 'Free', bestFor: 'Startups and solopreneurs', key: 'No-cost core features' },
    { name: 'Zoho Books', price: '$15/mo', bestFor: 'Zoho ecosystem users', key: 'Workflow automation' },
    { name: 'Sage', price: '$10/mo', bestFor: 'Compliance-heavy businesses', key: 'AI cash flow forecasting' },
    { name: 'Kashoo', price: '$20/mo', bestFor: 'Simplicity seekers', key: 'All-inclusive pricing' },
  ];

  return (
    <section className="mb-16">
      <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
        Side-by-Side Comparison
      </h2>
      <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-900 text-white">
              <th className="text-left px-5 py-4 font-semibold">Software</th>
              <th className="text-left px-5 py-4 font-semibold">Starting Price</th>
              <th className="text-left px-5 py-4 font-semibold">Best For</th>
              <th className="text-left px-5 py-4 font-semibold">Standout Feature</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr
                key={row.name}
                className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
              >
                <td className="px-5 py-4 font-medium text-gray-900">{row.name}</td>
                <td className="px-5 py-4 text-teal-700 font-semibold">{row.price}</td>
                <td className="px-5 py-4 text-gray-600">{row.bestFor}</td>
                <td className="px-5 py-4 text-gray-600">{row.key}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
